module.exports = __webpack_public_path__ + "static/img/6.d5cd120.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/eng/6.png
// module id = AUsq
// module chunks = 0